import {eventsActionTypes} from '../reducers/events';

export const setEventsData = data => ({
    type: eventsActionTypes.setData,
    data,
});



// WEBPACK FOOTER //
// ./src/redux/actions/events.js